module.exports = __webpack_public_path__ + "static/media/webtunes_vol4.02c3430f.png";